import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useQuery } from '@apollo/client';
import CssBaseline from '@mui/material/CssBaseline';
import Footer from 'components/Footer';
import Disclaimer from 'components/Disclaimer';
import MainSection from './MainSection';
import layoutQuery from 'components/Layout/getLayout.graphql';
import { useSiteSettings } from 'context/SiteSettingsContext';
import ErrorBoundary from 'components/ErrorBoundary';
import LoadingPage from 'components/LoadingPage';
import { DFPSlotsProvider } from 'react-dfp';

function Layout({
  children,
  title = 'tastylive | a real financial network | financial news and entertainment'
}) {
  const [showStickyAd, setShowStickyAd] = useState(true);
  const { loading, error, data } = useQuery(layoutQuery);
  const { siteSettings } = useSiteSettings();

  if (loading) {
    return <LoadingPage />;
  }

  const { header, footer } = (data && data.layout) || {};
  const { siteAlerts } = siteSettings || {};

  return (
    <>
      <CssBaseline />
      <Helmet>
        <title>{title}</title>
        <script async src="https://siteimproveanalytics.com/js/siteanalyze_6275188.js"></script>
      </Helmet>
      <DFPSlotsProvider dfpNetworkId={process.env.RAZZLE_DFP_NETWORK_ID || '27309309'} collapseEmptyDivs>
        <MainSection
          children={children}
          header={header}
          siteAlerts={siteAlerts}
          showStickyAd={showStickyAd}
        />
        <>
          {footer && (
            <ErrorBoundary component='footer'>
              <Footer data={footer} />
            </ErrorBoundary>
          )}
          {footer?.disclaimers && (
            <ErrorBoundary component='footer disclaimers'>
              <Disclaimer disclaimers={footer.disclaimers} />
            </ErrorBoundary>
          )}
        </>
      </DFPSlotsProvider>
    </>
  );
}

export default React.memo(Layout);
